var map = {
	"./avatar_antelope.inline.svg": [
		"YJiB",
		37
	],
	"./avatar_bear.inline.svg": [
		"NTvB",
		38
	],
	"./avatar_beaver.inline.svg": [
		"yjjJ",
		39
	],
	"./avatar_bee.inline.svg": [
		"zn2W",
		40
	],
	"./avatar_boar.inline.svg": [
		"FfAB",
		41
	],
	"./avatar_bull.inline.svg": [
		"rDx4",
		42
	],
	"./avatar_cangaroo.inline.svg": [
		"W8Kh",
		43
	],
	"./avatar_cat.inline.svg": [
		"x027",
		44
	],
	"./avatar_cow.inline.svg": [
		"1neT",
		45
	],
	"./avatar_coyote.inline.svg": [
		"uIGy",
		46
	],
	"./avatar_crocodile.inline.svg": [
		"6RtS",
		47
	],
	"./avatar_deer.inline.svg": [
		"6wl2",
		48
	],
	"./avatar_dog.inline.svg": [
		"bx0B",
		49
	],
	"./avatar_donkey.inline.svg": [
		"sNU3",
		50
	],
	"./avatar_dove.inline.svg": [
		"L97S",
		51
	],
	"./avatar_elephant.inline.svg": [
		"bYAl",
		52
	],
	"./avatar_fox.inline.svg": [
		"3IHO",
		53
	],
	"./avatar_frog.inline.svg": [
		"hMP4",
		54
	],
	"./avatar_giraffe.inline.svg": [
		"rbR4",
		55
	],
	"./avatar_goat.inline.svg": [
		"c727",
		56
	],
	"./avatar_hedgehog.inline.svg": [
		"am+l",
		57
	],
	"./avatar_hippo.inline.svg": [
		"deRG",
		58
	],
	"./avatar_koala.inline.svg": [
		"qUvX",
		59
	],
	"./avatar_ladybug.inline.svg": [
		"knSc",
		60
	],
	"./avatar_lion.inline.svg": [
		"vACX",
		61
	],
	"./avatar_monkey.inline.svg": [
		"S+1u",
		62
	],
	"./avatar_mouse.inline.svg": [
		"mZjx",
		63
	],
	"./avatar_octopus.inline.svg": [
		"kbcE",
		64
	],
	"./avatar_owl.inline.svg": [
		"Q1xs",
		65
	],
	"./avatar_panda.inline.svg": [
		"Z+mG",
		66
	],
	"./avatar_penguin.inline.svg": [
		"Vd9S",
		67
	],
	"./avatar_pig.inline.svg": [
		"w8fy",
		68
	],
	"./avatar_platypus.inline.svg": [
		"6sNp",
		69
	],
	"./avatar_rabbit.inline.svg": [
		"ROG5",
		70
	],
	"./avatar_raccoon.inline.svg": [
		"FJHj",
		71
	],
	"./avatar_rhino.inline.svg": [
		"5jhC",
		72
	],
	"./avatar_rooster.inline.svg": [
		"SIGQ",
		73
	],
	"./avatar_sheep.inline.svg": [
		"zGqW",
		74
	],
	"./avatar_snail.inline.svg": [
		"FPr8",
		75
	],
	"./avatar_snake.inline.svg": [
		"Vjtv",
		76
	],
	"./avatar_tiger.inline.svg": [
		"lO0j",
		77
	],
	"./avatar_walrus.inline.svg": [
		"H22Y",
		78
	],
	"./avatar_zebra.inline.svg": [
		"T4fW",
		79
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Cbfq";
module.exports = webpackAsyncContext;